import { Container } from "react-bootstrap";

function Terms() {
  return (
    <Container className="py-4 policy-page">
      <h2 className="mb-2">Terms and Conditions</h2>
      <p className="text-muted small">Last updated: 27 April 2026</p>

      <p>
        These Terms govern your use of the Dial Tutors platform, accessible at
        <a href="https://dialtutors.in"> dialtutors.in</a> (the “Platform”), operated by
        Dial Tutors (“we”, “our”, “us”). By creating an account, browsing the Platform, or
        making a payment, you agree to be bound by these Terms together with our
        <a href="/privacy"> Privacy Policy </a>and
        <a href="/refund"> Refund Policy</a>. If you do not agree, please do not use the
        Platform.
      </p>

      <h5 className="mt-4">1. About the platform</h5>
      <p>
        Dial Tutors is an online marketplace that connects students and parents looking for
        home tuition with independent tutors offering academic, music, arts, and fitness
        instruction. We facilitate discovery, booking, payment, attendance, and ratings. We
        do not employ the tutors and do not directly deliver the teaching service.
      </p>

      <h5 className="mt-4">2. Eligibility and accounts</h5>
      <ul>
        <li>You must be at least 18 years of age to register on the Platform.</li>
        <li>
          For students under 18, the account must be created and operated by a parent or
          legal guardian, who is solely responsible for the minor’s use of the Platform.
        </li>
        <li>
          You must provide accurate, current, and complete information and update it when it
          changes. You are responsible for safeguarding your password and for all activity
          on your account.
        </li>
        <li>
          You may not create multiple accounts, transfer your account, or impersonate any
          other person.
        </li>
      </ul>

      <h5 className="mt-4">3. Tutor onboarding and verification</h5>
      <ul>
        <li>
          Tutors must submit accurate qualifications, identity proof, and contact details.
          We may verify these directly or via authorised third parties.
        </li>
        <li>
          A non-refundable registration fee may apply once verification commences (see the
          <a href="/refund"> Refund Policy</a>).
        </li>
        <li>
          Approval is at our sole discretion. We may suspend or remove a tutor for breach of
          these Terms, repeated complaints, or unsafe conduct.
        </li>
      </ul>

      <h5 className="mt-4">4. Bookings, demos, and hires</h5>
      <ul>
        <li>
          A booking creates a hold on the student’s wallet equal to the demo fee plus the
          monthly fee. The hold is released or paid out based on demo outcome and hire
          decision.
        </li>
        <li>
          A successful demo may be converted to a hire, in which case the student pays for
          subsequent months in advance through the wallet.
        </li>
        <li>
          Each party agrees to be reasonable about scheduling and cancellations, including
          providing at least 24 hours’ notice where possible.
        </li>
      </ul>

      <h5 className="mt-4">5. Payments, fees, and commission</h5>
      <ul>
        <li>
          All amounts are in Indian Rupees (INR) and are inclusive of applicable taxes
          unless stated otherwise.
        </li>
        <li>
          Payments are processed through regulated payment gateways. By initiating a
          payment you agree to the gateway’s terms in addition to ours.
        </li>
        <li>
          Dial Tutors retains a commission on each successful settlement to a tutor at the
          rate displayed in your dashboard at the time of the transaction. The remainder is
          paid to the tutor net of taxes.
        </li>
        <li>
          You agree that statements, invoices, and receipts may be issued electronically.
        </li>
      </ul>

      <h5 className="mt-4">6. User conduct</h5>
      <ul>
        <li>Treat other users with respect; harassment, abuse, or threats are prohibited.</li>
        <li>
          Do not bypass the Platform to take payments outside Dial Tutors for tuition
          arranged through the Platform — this circumvents commissions and disputes
          protections, and may lead to permanent suspension.
        </li>
        <li>
          Do not upload illegal, infringing, defamatory, or sexually explicit content.
        </li>
        <li>Do not attempt to disrupt, reverse engineer, or scrape the Platform.</li>
      </ul>

      <h5 className="mt-4">7. Intellectual property</h5>
      <p>
        The Dial Tutors brand, logo, layout, and software are owned by us and protected by
        copyright and trademark laws. You may use the Platform for its intended purpose but
        may not reproduce or redistribute any part of it without written permission.
      </p>

      <h5 className="mt-4">8. Reviews and ratings</h5>
      <p>
        Students may rate and review tutors based on their genuine experience. Reviews must
        be honest and free of personal attacks. We reserve the right to remove reviews that
        violate these Terms or applicable law.
      </p>

      <h5 className="mt-4">9. Disclaimers</h5>
      <p>
        The Platform is provided on an “as is” and “as available” basis. While we screen
        tutors with reasonable care, we do not guarantee any specific learning outcome,
        score improvement, or compatibility. Tutors are independent contractors and not
        agents or employees of Dial Tutors.
      </p>

      <h5 className="mt-4">10. Limitation of liability</h5>
      <p>
        To the maximum extent permitted by law, our aggregate liability for any claim arising
        out of or in connection with the Platform is limited to the total amount paid by you
        to Dial Tutors in the 30 days preceding the event giving rise to the claim. We are
        not liable for indirect, incidental, or consequential damages.
      </p>

      <h5 className="mt-4">11. Indemnity</h5>
      <p>
        You agree to indemnify and hold harmless Dial Tutors and its personnel from any
        claim, loss, or demand arising out of your breach of these Terms, your content, or
        your use of the Platform.
      </p>

      <h5 className="mt-4">12. Suspension and termination</h5>
      <p>
        We may suspend or terminate your access if you breach these Terms, if your account
        is involved in suspected fraud, or if continued service is not commercially viable.
        On termination, pending dues will be settled in line with the Refund Policy.
      </p>

      <h5 className="mt-4">13. Governing law and jurisdiction</h5>
      <p>
        These Terms are governed by the laws of India. Disputes will be subject to the
        exclusive jurisdiction of the competent courts at our registered office location.
      </p>

      <h5 className="mt-4">14. Changes to these terms</h5>
      <p>
        We may update these Terms from time to time. Material changes will be notified by
        email or via an in-app banner, and the updated version will be posted on this page
        with a new “Last updated” date. Continued use of the Platform after such updates
        constitutes acceptance.
      </p>

      <h5 className="mt-4">15. Contact</h5>
      <ul className="list-unstyled">
        <li><strong>Email:</strong> <a href="mailto:support@dialtutors.in">support@dialtutors.in</a></li>
        <li><strong>Phone:</strong> <a href="tel:7448337000">7448337000</a></li>
      </ul>
    </Container>
  );
}

export default Terms;
